// extracted by mini-css-extract-plugin
module.exports = {"lobby":"styles-module__lobby___2KBC8","quickLinks":"styles-module__quickLinks___7mTpb"};